import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const SidebarItem = ({children, eventKey, to, disabled}) => {


    return (
        <Nav.Item className="px-2 px-md-3 py-2">
            <Nav.Link as={Link} to={to} className="text-white d-flex rounded align-items-center py-3 px-3 hov-bg-2" eventKey={eventKey} disabled={disabled}>
                {children}
            </Nav.Link>
        </Nav.Item>
    );
}

export default SidebarItem;